import React from 'react'
import { Outlet } from 'react-router-dom'
import { Grid } from '@mui/material'
import { useStyles } from './style'
import { TopRectangles, useTenant } from '@emerald-works-nova/auth'
import consts from '../../consts'

const AuthLayout = () => {
  const classes = useStyles()
  const tenant = useTenant()
  const isClubOrAdminTenant = [consts.DEFAULT_CLUB_TENANT_KEY, consts.DEFAULT_ADMIN_TENANT_KEY].includes(tenant?.tenantKey)

  return (
    <>
      {isClubOrAdminTenant && (
        <div className={classes.rectBarContainer}>
          <TopRectangles />
        </div>
      )}

      <Grid
        container
        direction='column'
        wrap='nowrap'
        className={classes.container}
      >
        <Grid item className={classes.mainContainer}>
          <main>
            <Outlet />
          </main>
        </Grid>
      </Grid>
    </>
  )
}

export default AuthLayout
